import { render, staticRenderFns } from "./ModalRequestPickup.vue?vue&type=template&id=646cc2ba&"
import script from "./ModalRequestPickup.vue?vue&type=script&lang=js&"
export * from "./ModalRequestPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports